/* eslint-disable @typescript-eslint/no-empty-function */
import { ReactElement, useState, createContext } from 'react';
import { AppConfiguration } from '../lib/type';
import './FlashSustainabilityCalculator.scss';
import SingleItemSelect from './SingleItemSelect/SingleItemSelect';
import ComparisonTable from './ComparisonTable/ComparisonTable';
import AssumptionsTable from './AssumptionsTable/AssumptionsTable';
import messages from '../locales/messages';
import { FormattedMessage } from 'react-intl';
import '../../../common/style/CarbonV2Fixes.scss';

export interface FlashSustainabilityCalculatorProps {
  /**
   * All the configuration for the map
   */
  configuration: AppConfiguration;
}

// Defining a type for selectedOption context element
type selectedOptionObject = {
  usableStorage: number;
  performanceLevel: string;
};

type countryData = {
  code: string;
  name: JSX.Element;
  exchangeRate: number;
  currencySymbol: string;
  electricity: number;
  carbonFactor: number;
};

export const layoutContext = createContext<{
  selectedOption?: selectedOptionObject;
  setSelectedOption?: React.Dispatch<
    React.SetStateAction<selectedOptionObject>
  >;
  currentCountry?: countryData;
  setCurrentCountry?: React.Dispatch<React.SetStateAction<countryData>>;
}>({});

const FlashSustainabilityCalculator = ({
  configuration,
}: FlashSustainabilityCalculatorProps): ReactElement => {
  const [selectedOption, setSelectedOption] = useState<selectedOptionObject>({
    usableStorage: 50,
    performanceLevel: 'medium',
  });
  const [currentCountry, setCurrentCountry] = useState<countryData>({
    code: 'USA',
    name: <FormattedMessage {...messages.unitedStates} />,
    exchangeRate: 1,
    currencySymbol: '$',
    electricity: 0.268,
    carbonFactor: 367.3,
  });

  return (
    <layoutContext.Provider
      value={{
        selectedOption,
        setSelectedOption,
        currentCountry,
        setCurrentCountry,
      }}
    >
      <div className="flash-sustainability-calculator_wrapper widget-styles">
        <div className="flash-sustainability-calculator_single-select-wrapper">
          <SingleItemSelect contents={configuration.usableStorage} />
          <SingleItemSelect contents={configuration.performanceLevel} />
          <ComparisonTable contents={configuration.comparisonTable} />
          <AssumptionsTable contents={configuration.assumptionsTable} />
        </div>
      </div>
    </layoutContext.Provider>
  );
};

export default FlashSustainabilityCalculator;
